import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

const sizeMap = {
  xs: 'h-3 w-3',
  sm: 'h-3.5 w-3.5',
  md: 'h-4 w-4',
  lg: 'h-5 w-5',
  xl: 'h-6 w-6',
  '2xl': 'h-8 w-8',
} as const;

const toneMap = {
  inherit: '',
  muted: 'text-muted-foreground',
  primary: 'text-primary',
  onDark: 'text-white',
} as const;

export type SpinnerSize = keyof typeof sizeMap;
export type SpinnerTone = keyof typeof toneMap;

export function Spinner({
  size = 'md',
  tone = 'inherit',
  className,
}: { size?: SpinnerSize; tone?: SpinnerTone; className?: string }) {
  return (
    <Loader2
      className={cn('animate-spin shrink-0', sizeMap[size], toneMap[tone], className)}
      aria-hidden="true"
    />
  );
}
